import React, { useContext, useEffect, useState } from 'react';
import { Button } from '@material-ui/core';

import { doorDashApi } from 'api/doorDash';
import { goPuffApi } from 'api/goPuff';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications, WholesaleAccountPicker } from 'shared';

function ViewGoPuffPackout() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const user = useContext(UserContext);
    const { wholesaleAccount } = useContext(UserContext);
    const [api, setApi] = useState(wholesaleAccount.fbmAccountName === 'doordash' ? doorDashApi : goPuffApi);

    const getRows = async () => {
        const response = await api.getPackoutRows(user.getFacilityID());
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.rows ? response.data.rows : []);
    };

    useEffect(() => {
        if (wholesaleAccount.fbmAccountName === 'doordash') {
            setApi(doorDashApi);
        } else {
            setApi(goPuffApi);
        }
    }, [wholesaleAccount]);

    useEffect(() => {
        if (wholesaleAccount.id) {
            getRows();
        }
    }, [api]);

    const cols = [
        { accessor: 'packDate', Header: 'Pack Date' },
        { accessor: 'count', Header: 'Num Shipments' },
        {
            accessor: 'download',
            Header: 'Download',
            Cell: ({ cell: { value: initialValue }, column, editable, row, saveEdit }) => (
                <Button
                    id="Download"
                    onClick={async () => {
                        const res = await api.sendPackoutFile(user.getFacilityID(), row.original.packDate);
                        if (!res.status) {
                            setNotification({ text: `Failed to send packout file. ${res.msg}`, level: 'error' });
                            return;
                        }
                        setNotification({ text: 'Pack out file processing. Wait for email', level: 'success' });
                    }}
                >
                    Send File
                </Button>
            ),
        },
    ];

    return (
        <div>
            <WholesaleAccountPicker />
            {!!wholesaleAccount.id && (
                <>
                    <h1>{wholesaleAccount.companyName} Packout files</h1>
                    <h2>Your file will be emailed to you. Please wait 10-15 minutes for completion.</h2>
                    <Notifications options={notification} />
                    <div>
                        <DataTable columns={cols} data={rows} />
                    </div>
                </>
            )}
        </div>
    );
}

export { ViewGoPuffPackout };
